import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDefaultLandingRoute } from '../permissions/landingRoute';
import { usePermissionState } from '../stores/permissionStore';
import { PermissionsLoadFailure } from './RequireAppView';

export default function DefaultLandingRedirect() {
    const permissionState = usePermissionState();
    const userCompany = useSelector((state) => state.CompanyReducer.userCompanies);

    if (permissionState.error) {
        return <PermissionsLoadFailure />;
    }

    if (!permissionState.loaded) {
        return null;
    }

    const landingRoute = getDefaultLandingRoute(permissionState, userCompany) ?? '/account';
    return <Navigate to={landingRoute} replace />;
}
